import { render, staticRenderFns } from "./automaticModels.vue?vue&type=template&id=cd2561e6&scoped=true&"
import script from "./automaticModels.vue?vue&type=script&lang=js&"
export * from "./automaticModels.vue?vue&type=script&lang=js&"
import style0 from "./automaticModels.vue?vue&type=style&index=0&id=cd2561e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2561e6",
  null
  
)

export default component.exports